module.exports = __webpack_public_path__ + "static/media/040.be68a860.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/040.jpg
// module id = 336
// module chunks = 0